/** @format */
import { $utils } from '@/utils/publicUtils';

const common = {
	PAGE: 1,
	LIMIT: 20,
};

const ActionUtils = {
	/**
	 * 处理列表数据
	 * @param vm 当前对象
	 * @param data 后台返回的列表数据
	 * @param options 参数
	 *   dataResultKey 默认 dataResult
	 *  pageResultKey 默认 pageResult
	 *  resultKey 结果key 默认 listData
	 *  pageKey 分页key 默认 pagination
	 */
	handleListData(vm, data, options = {}) {
		// 备注：在这里把分页数据改造成之前代码里边的格式
		data['pageResult'] = {
			limit: data.pageSize,
			page: data.page,
			totalCount: data.total,
			totalPages: data.pages,
		};
		const dataResultKey = options.dataResultKey || 'rows';
		const pageResultKey = options.pageResultKey || 'pageResult';
		const resultKey = options.resultKey || 'listData';
		const pageKey = options.pageKey || 'pagination';
		vm[resultKey] = data ? data[dataResultKey] || [] : [];
		vm[pageKey] = data
			? data[pageResultKey] || {
					page: common.PAGE,
					limit: common.LIMIT,
			  }
			: {
					page: common.PAGE,
					limit: common.LIMIT,
			  };
	},
	formatParams(params, pagination, sorts) {
		const results = {};
		if (params) {
			results.parameters = Object.keys(params).map((k) => {
				const paramValue = params[k];
				if ($utils.isObject(paramValue) && paramValue['relation']) {
					return paramValue;
				} else {
					return {
						code: k,
						value: paramValue,
					};
				}
			});
		}
		if (pagination) {
			results.requestPage = {
				pageNo: pagination.page || common.PAGE,
				limit: pagination.limit || common.LIMIT,
			};
			if ($utils.isNotEmpty(pagination.totalCount)) {
				// mock 数据时候要传
				results.requestPage['totalCount'] = pagination.totalCount;
			}
		}
		if (sorts) {
			results.sorts = Object.keys(sorts).map((k) => {
				return {
					field: k,
					order: sorts[k],
				};
			});
		}
		return results;
	},
	setPagination(pagination, defaultPagination) {
		// 修复通过查询
		if (!defaultPagination) {
			defaultPagination = {
				page: common.PAGE,
				limit: pagination ? pagination.limit || common.LIMIT : common.LIMIT,
			};
		}
		pagination.page = defaultPagination ? defaultPagination.page || common.PAGE : pagination.page || common.PAGE;
		pagination.limit = defaultPagination ? defaultPagination.limit || common.LIMIT : pagination.limit || common.LIMIT;
	},
	// 设置排序
	setSorts(sorts, sort, defaultSorts = {}) {
		const defaultSortsData = function () {
			for (const key in defaultSorts) {
				sorts[key] = defaultSorts[key];
			}
			// 清空属性
			for (const key in sorts) {
				delete sorts[key];
			}
		};
		defaultSortsData();
		if (sort) {
			const { name, sortBy, order } = sort;
			if (name && order) {
				sorts[name] = order === 'ascending' ? 'ASC' : 'DESC';
			} else if (sortBy && order) {
				sorts[sortBy] = order === 'ascending' ? 'ASC' : 'DESC';
			} else {
				defaultSortsData();
			}
		} else {
			defaultSortsData();
		}
	},
	/**
	 * 设置分页第一页设置
	 * @param {*} pagination
	 * @param {*} defaultPagination
	 */
	setFirstPagination(pagination) {
		pagination.page = common.PAGE;
	},
};

export { ActionUtils };
